import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'gc-datepicker-item',
  templateUrl: './datepicker-item.component.html',
  styleUrls: ['./datepicker-item.component.scss'],
})
export class DatepickerItemComponent implements AfterViewInit, OnDestroy {
  @ViewChild('picker') picker?: MatDatepicker<Date>;
  private readonly destroy$ = new Subject<void>();
  private didConfirmSelection = false;

  @Input() disabled = false;
  @Input() control?: UntypedFormControl | null;
  @Input() placeHolder = '';
  @Input() max?: string;
  @Input() min?: string;
  @Input() presentation = 'date';
  @Input() size = 'cover';
  @Input() lines = 'full';
  @Input() closeOn!: 'select' | 'submit';
  @Input() closeOnSelect = false;
  @Input() showSubmit = false;
  @Input() autoOpen = false;
  @Input() hideField = false;

  @Output() dismissed = new EventEmitter<'cancel' | 'confirm'>();

  ngAfterViewInit(): void {
    if (this.picker) {
      this.picker.openedStream.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.didConfirmSelection = false;
      });
      this.picker.closedStream.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (!this.didConfirmSelection) {
          this.dismissed.emit('cancel');
        }
      });
    }

    if (this.autoOpen && !this.disabled) {
      // Allow overlay host (e.g. popover) to render before opening datepicker.
      setTimeout(() => this.picker?.open());
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  confirmSelection(): void {
    this.didConfirmSelection = true;
    this.dismissed.emit('confirm');
  }

  get minDate(): Date | null {
    if (!this.min) return null;
  
    if (this.min === 'today') {
      return new Date(new Date().setHours(0, 0, 0, 0) + 86400000);
    }

    return new Date(this.min);
  }
}
